import React from 'react';

function MediaTypeDropdown({ name, id, value, onChange }) {
  return (
    <select
      name={name}
      id={id}
      value={value}
      onChange={onChange} // Make sure this is passed through
      className="w-32 rounded-md border-0 pl-2 pr-8 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
    >
      <option value="Spot">Spot</option>
      <option value="Trade">Trade</option>
      <option value="Package">Package</option>
      <option value="Bonus">Bonus</option>
      <option value="Make Good">Make Good</option>
      <option value="Custom">Custom</option>
    </select>
  );
}

export default MediaTypeDropdown;